export enum ELayeringOrder {
    GAME_BACKGROUND = 30,
    REELS_BACKGROUND = 50,
    SYMBOL_MASK_START = 51,
    REELS = 52,
    SYMBOL_MASK_END = 53,
    REEL = 54,
    ABOVE_REELS = 55,
    TENSION = 56,
    LOSING_SYMBOLS_LAYER = 57,
    WINNING_SYMBOLS_NOT_ON_LINE_LAYER = 58,
    STICKY_SYMBOLS_LAYER = 59,
    WINLINES = 61,
    WINNING_SYMBOLS_LAYER = 62,
    EXPANDED_WILD_LAYER = 63,
    WAYS = 64,
    INFO_DISPLAY = 65,
    UNDER_WIN = 80,
    UNDER_WIN_PARTICLES = 81,
    WIN = 82,
    ODOMETER = 83,
    ABOVE_WIN_PARTICLES = 84,
    ABOVE_WIN = 85,
    SPECIAL_GAMES = 86,
    SPECIAL_GAMES_TEXT = 87,
    GAMBLE = 90,
    GAMBLE_ELEMENTS = 91,
    GAMBLE_RESULT = 92,
    ABOVE_ALL = 100
}
